import React, { Component } from "react";
import PropTypes from "prop-types";
import { View, StyleSheet, ViewPropTypes } from "react-native";
import STextField from "styled42/components/STextField";
import { Colors } from "styled42/config";
import { TEST_IDS, ACCESSIBILITY_LABEL } from "utils/testIds/index";

export default class OtpInput extends Component {
  /* eslint-disable */
  static propTypes = {
    containerStyles: ViewPropTypes.style,
    error: PropTypes.bool,
    focusedBorderColor: PropTypes.string,
    handleBackspace: PropTypes.func.isRequired,
    inputStyles: ViewPropTypes.style,
    textErrorColor: PropTypes.string,
    unFocusedBorderColor: PropTypes.string,
    updateText: PropTypes.func.isRequired,
    value: PropTypes.string
  };
  /* eslint-enable */

  state = {
    isFocused: false
  };

  onFocus = () => this.setState({ isFocused: true });

  onBlur = () => this.setState({ isFocused: false });

  render() {
    const {
      containerStyles,
      error,
      focusedBorderColor,
      handleBackspace,
      inputStyles,
      textErrorColor,
      unFocusedBorderColor,
      updateText,
      value,
      fieldWidth,
      keyIs
    } = this.props;

    const { isFocused } = this.state;
    return (
      <View
        style={[
          defaultStyles.container,
          containerStyles,
          {
            borderColor: isFocused ? focusedBorderColor : unFocusedBorderColor
          }
        ]}
      >
        <STextField
          autoFocus={keyIs === 0}
          keyboardType="phone-pad"
          maxLength={5}
          onBlur={this.onBlur}
          onChangeText={updateText}
          onFocus={this.onFocus}
          onKeyPress={handleBackspace}
          inputRef={(input) => {
            this.input = input;
          }}
          selectTextOnFocus
          key={fieldWidth}
          containerStyle={[
            defaultStyles.otpInput,
            // { width: fieldWidth || defaultStyles.otpInput.width },
            inputStyles,
            error ? { backgroundColor: Colors.Red[13] } : null
          ]}
          rowStyle={[error ? defaultStyles.errorStyle : null]}
          inputStyle={[defaultStyles.inputBox]}
          underlineColorAndroid="transparent"
          value={value}
          testID={`${TEST_IDS.OTP_EDIT_TEXT_BOX}_${keyIs+1}`}
          accessibilityLabel={`${ACCESSIBILITY_LABEL.OTP_EDIT_TEXT_BOX} ${keyIs+1}`}
        />
      </View>
    );
  }
}

const defaultStyles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    margin: 6
  },
  otpInput: {
    width: 48,
    height: 48
  },
  inputBox: {
    color: "#333",
    fontSize: 16,
    textAlign: "center",
    width: "100%"
  },
  errorStyle: {
    borderColor: Colors.Red[6],
    borderStyle: "solid",
    borderWidth: 1
  }
});
